'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _commonMenuItemBuilder = require('./commonMenuItemBuilder');

var _commonMenuItemBuilder2 = _interopRequireDefault(_commonMenuItemBuilder);

var _secondaryMenuItem = require('./secondaryMenuItem');

var _secondaryMenuItem2 = _interopRequireDefault(_secondaryMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Secondary Menu Item builder
 * @augments CommonMenuItemBuilder
 * @constructor
 */
/**
 * @module navigation/secondaryMenuItemBuilder
 * @requires module: navigation/commonMenuItemBuilder
 * @requires module: navigation/secondaryMenuItem
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function SecondaryMenuItemBuilder() {
  _commonMenuItemBuilder2.default.prototype.constructor.apply(this, arguments);

  this.ItemConstructor = _secondaryMenuItem2.default;
  this.activeClass = 'ui-link_marked';

  this.outerClass = 'rn-secondaryNav__list__item';
  this.innerClass = 'rn-secondaryNav__list__link ui-link';
}
SecondaryMenuItemBuilder.prototype = (0, _create2.default)(_commonMenuItemBuilder2.default.prototype);

exports.default = SecondaryMenuItemBuilder;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/secondaryMenuItemBuilder.js
// module id = 2685
// module chunks = 1